/**
 * Generic utility function to convert an array of objects into a Map
 * @param array - Array of objects to convert
 * @param keySelector - Function to extract the key from each object
 * @param valueSelector - Function to extract the value from each object (optional, defaults to the object itself)
 */
export function arrayToMap<T, K, V = T>(
  array: T[] | undefined,
  keySelector: (item: T) => K,
  valueSelector?: (item: T) => V
): Map<K, V> {
  const map = new Map<K, V>();
  
  if (!array) return map;
  
  array.forEach(item => {
    const key = keySelector(item);
    const value = valueSelector ? valueSelector(item) : (item as unknown as V);
    map.set(key, value);
  });
  
  return map;
}
